<div class="fulfill-batch-list">
  @if (showBatchHistory()) {
    <fulfill-batch-history-modal [parent]="this" (onClose)="showBatchHistory.set(false)"> </fulfill-batch-history-modal>
  }
  <div class="fulfill-batch-list__header">
    <pdq-tabs-group (onChange)="setActiveTab($event)">
      <pdq-tab
        [active]="activeTab === OrderBatchCategory.FULFILLMENT_READY"
        [value]="OrderBatchCategory.FULFILLMENT_READY"
        [label]="fulfillmentTabLabel()"
        [loading]="fulfillmentCountLoading()"></pdq-tab>
      <pdq-tab
        [active]="activeTab === OrderBatchCategory.DELIVERY_READY"
        [value]="OrderBatchCategory.DELIVERY_READY"
        [label]="deliveryTabLabel()"
        [loading]="deliveryCountLoading()"></pdq-tab>
    </pdq-tabs-group>
    <div class="fulfill-batch-list__actions">
      <pdq-button
        label="Shipping manifests"
        icon="manifest"
        variant="ghost"
        iconColor="var(--on-surface-light)"
        size="medium"
        (onClick)="shippingManifests()"></pdq-button>
      <pdq-button label="Scan order" icon="scan" variant="dark" size="medium" (onClick)="scanLabel()"></pdq-button>
    </div>
  </div>
  <div class="section-wrapper" [style.--header-height]="layoutService.headerHeight$() + 'px'">
    @switch (activeTab) {
      @case (OrderBatchCategory.FULFILLMENT_READY) {
        <fulfill-batch-list-table-v2
          #fulfillmentTable
          [category]="OrderBatchCategory.FULFILLMENT_READY"
          [pdqUsersList]="pdqUsersList"
          [columns]="columns"
          [title]="'Fulfillment ready'"
          [allowReorder]="true"
          [batchesState]="fulfillmentReadyBatches()"
          [totalCount]="fulfillmentReadyTotalCount()"
          [countLoading]="fulfillmentCountLoading()"
          (loadPage)="onLoadPage(OrderBatchCategory.FULFILLMENT_READY, $event)"
          (filterChange)="setFilters(OrderBatchCategory.FULFILLMENT_READY, $event)"
          (pageSizeChange)="handlePageSizeChange($event)"
          (batchReorder)="onBatchReorder(OrderBatchCategory.FULFILLMENT_READY, $event)">
        </fulfill-batch-list-table-v2>
      }
      @case (OrderBatchCategory.DELIVERY_READY) {
        <fulfill-batch-list-table-v2
          #deliveryTable
          [category]="OrderBatchCategory.DELIVERY_READY"
          [pdqUsersList]="pdqUsersList"
          [columns]="columns"
          [title]="'Delivery ready'"
          [batchesState]="deliveryReadyBatches()"
          [totalCount]="deliveryReadyTotalCount()"
          [countLoading]="deliveryCountLoading()"
          (loadPage)="onLoadPage(OrderBatchCategory.DELIVERY_READY, $event)"
          (filterChange)="setFilters(OrderBatchCategory.DELIVERY_READY, $event)"
          (pageSizeChange)="handlePageSizeChange($event)">
        </fulfill-batch-list-table-v2>
      }
    }
  </div>
  <footer>
    <pdq-link label="Batch history" (onClick)="showBatchHistory.set(true)"></pdq-link>
  </footer>
</div>
